import { Outlet } from "react-router-dom";

import { Logo } from "@/components/logo";
import { Version } from "@/components/version";

export function AuthLayout() {
  return (
    <div className="flex min-h-full flex-1 flex-col justify-center bg-top bg-no-repeat py-12 sm:bg-square sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="border-border bg-background sm:rounded-lg sm:border sm:shadow-xl">
          <div className="px-4 pb-6 pt-8 sm:px-6 sm:pt-11">
            <Logo />
          </div>
          <Outlet />
        </div>
      </div>
      <Version />
    </div>
  );
}
